module.exports = "pegasus_template/assets/blocks/capture-1-basic.png";